<script setup lang="ts">
import { type BuildPlatform } from '@webapp2/shared/model'
import { platformLogo } from './platform-image'

const props = defineProps<{
  platform: BuildPlatform
}>()
</script>

<template>
  <img v-tooltip="platform" :src="platformLogo[platform]" class="object-contain" :alt="platform" />
</template>
